<script>
import * as moment from 'moment'
import { orderStatusColorVariant } from '@/sales/filters/statuses';

export default {
  filters: {
    orderStatusColorVariant,
  },

  props: {
    orders: { type: Array, required: true },
  },

  computed: {
    hasNoOrders() { return this.orders.length === 0 },
  },

  methods: {
    nonZeroItemCount(order) { return order.items.filter(x => x.driver_quantity > 0 || x.office_quantity > 0).length },

    getOrderGroup(order) {
      //TODO: Duplicate in layers EggOrdersListOpen.vue
      let startOfWeek = moment().startOf('isoWeek');
      if (moment(order.date).isBefore(startOfWeek)) {
        return 'Older';
      }
      return 'This week';
    },

    orderSeparatorText(order, orders) {
      //TODO: Duplicate in layers EggOrdersListOpen.vue
      let idx = orders.indexOf(order);

      if (idx === 0 || this.getOrderGroup(order) !== this.getOrderGroup(orders[idx - 1])) {
        return this.getOrderGroup(order);
      }

      return undefined;
    },
  },
}
</script>

<template>
  <div>
    <b-list-group flush>
      <b-list-group-item>
        <h4 class="text-center">Egg Orders</h4>
      </b-list-group-item>

      <template v-for="order in orders">
        <b-list-group-item v-if="orderSeparatorText(order, orders)" :key="`separator-before-order-${order.id}`">
          <div class="h4"> {{ orderSeparatorText(order, orders) }} </div>
        </b-list-group-item>

        <b-list-group-item :key="order.id" class="d-flex align-items-center">
          <b-badge class="mr-2" :variant="order.status | orderStatusColorVariant" style="width:80px"> {{order.status}} </b-badge>

          <div>
            <router-link :to="{name: 'sales/egg-order/by-id', params:{id: order.id}}"> {{order.date | formatDate('YYYY-MM-DD ddd')}} </router-link>
          </div>

          <b-badge class="ml-auto"> {{nonZeroItemCount(order)}} items </b-badge>
        </b-list-group-item>
      </template>

      <b-list-group-item v-if="hasNoOrders">
        You do not have any Egg Orders yet.
      </b-list-group-item>

      <b-list-group-item>
        <router-link :to="{name:'sales/egg-order-add'}" class="btn btn-success btn-block">Create Order</router-link>
      </b-list-group-item>
    </b-list-group>

  </div>
</template>



// WEBPACK FOOTER //
// src/sales/components/EggOrders.vue